import { createFileRoute } from '@tanstack/react-router';
import { RfqInboxPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/rfq/')({ component: RfqInboxPage });
